import StencilGrid from "./StencilGrid";

const RenderStencils = ({
  gridRef,
  setKeywords,
  keywords,
  setIsSelected,
  isSelected,
  setSelectedStencil,
  selectedStencil,
}) => {

  return (
    <div>
      <StencilGrid
        ref={gridRef}
        setKeywords={setKeywords}
        keywords={keywords}
        setIsSelected={setIsSelected}
        isSelected={isSelected}
        setSelectedStencil={setSelectedStencil}
        selectedStencil={selectedStencil}
      />
    </div>
  );
};

export default RenderStencils;
